import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackSpecialist } from '../../utils/helpers/metrics_helper';
import { selectIsFetching } from '../../selectors/mainpage';

import { SpecialistListRedesign } from '../../components/SpecialistListRedesign';
import { useSpecialists } from './hooks/useSpecialists';

interface ISpecialistsContainerProps {
  section: string;
}

export const SpecialistsContainer: React.FC<ISpecialistsContainerProps> = ({ section }) => {
  const isFetching = useSelector(selectIsFetching);
  const specialists = useSpecialists(section);

  const handleItemClick = React.useCallback((eventLabel: string) => trackSpecialist(eventLabel), []);

  if (!specialists.length || isFetching) {
    return null;
  }

  return (
    <>
      {specialists.map(specialistBlock => (
        <SpecialistListRedesign
          key={specialistBlock.key}
          specialists={specialistBlock}
          onItemClick={() => handleItemClick(specialistBlock.key)}
        />
      ))}
    </>
  );
};
